import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth'
import {setToken} from "./utils/auth"; // 验权

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  next();
  NProgress.start()
  console.log(to)
  if (to.path === '/directLogin') {
    console.log(123)
    NProgress.done()
  return
  }

  console.log(getToken())
  if (getToken()) {
    if (to.path === '/login') {
      next({path: '/'})
      // NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      // if (store.getters.roles.length === 0) {
      //   store.dispatch('GetInfo').then(res => { // 拉取用户信息
      //     let menus = res.data.menus;
      //     let username = res.data.username;
      //   })
      // } else {
      //   NProgress.done()
      //   next()
      // }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      NProgress.done()
      next()

    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js